// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shared-modal-edit-piece-advanced-settings{display:flex;flex-direction:column;gap:32px}.shared-modal-edit-piece-advanced-settings .control-label{font-weight:700}", ""]);
// Exports
module.exports = exports;
